import { useState } from 'react';

import { resetFilters, submitFilters } from '@screens/Category/model/slice/categorySlice';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';

import cls from './Buttons.module.scss';

export const Buttons = () => {
  const dispatch = useAppDispatch();
  const filteredProductsCount = useAppSelector((state) => state.category.filteredProductsCount);
  const resetButtonLoading = useAppSelector((state) => state.category.resetButtonLoading);
  const submitButtonLoading = useAppSelector((state) => state.category.submitButtonLoading);
  const [abortController, setAbortController] = useState(new AbortController());

  const resetFilterHandler = async () => {
    abortController.abort();
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    dispatch(resetFilters({ signal: newAbortController.signal }));
  };

  const submitFilter = async () => {
    abortController.abort();
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    dispatch(submitFilters({ update: true, signal: newAbortController.signal }));
  };

  return (
    <div className={cls.bot}>
      <Button
        onClick={resetFilterHandler}
        fullWidth
        loadingButton
        isLoading={resetButtonLoading}
        className={cls.btn}
        variant={'secondary'}
        testId={'filter-reset-button'}
      >
        Сбросить все
      </Button>
      <Button
        isLoading={submitButtonLoading}
        onClick={submitFilter}
        fullWidth
        loadingButton
        className={cls.btn}
        variant={'accent'}
        testId={'filter-submit-button'}
      >
        Показать <span>({filteredProductsCount})</span>
      </Button>
    </div>
  );
};
